module.exports = __webpack_public_path__ + "img/our5.475ce8b5.svg";